module.exports = __webpack_public_path__ + "img/star-fill.a355bfbb.svg";